// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2m13C","header":"ReportDetails_header__F4TmE","title":"ReportDetails_title__iPePE","left":"ReportDetails_left__tO-8B"};